import VueRouter, { RouteConfig } from 'vue-router';

export default (router: VueRouter): RouteConfig[] => {
  return [
    {
      path: '/auth',
      name: 'auth',
      component: () => import('@/views/auth/Auth.vue'),
      redirect: { name: 'login' },
      children: [
        {
          path: 'login',
          name: 'login',
          component: () => import('@/views/auth/Login.vue'),
          meta: {
            auth: false,
            fullscreen: true,
          },
        },
        {
          path: 'role_select',
          name: 'role-select',
          component: () => import('@/views/auth/RoleSelect.vue'),
          meta: {
            fullscreen: true,
          },
        },
        {
          path: 'password_reset',
          name: 'password-reset',
          component: () => import('@/views/auth/PasswordReset.vue'),
          meta: {
            fullscreen: true,
          },
        },
        {
          path: 'forgot_password',
          name: 'forgot-password',
          component: () => import('@/views/auth/ForgotPassword.vue'),
          meta: {
            auth: false,
            fullscreen: true,
          },
        },
        {
          path: 'set_password',
          name: 'set-password',
          component: () => import('@/views/auth/ForgotPassword.vue'),
          meta: {
            auth: false,
            fullscreen: true,
          },
        },
      ],
    },
  ];
};
